<template>
  <div class="greyed-out">
    <div>
      Lorem ipsum: Dolor sit amet, consectetur adipiscing elit:

      Duis vulputate: Aliquet purus.

      Integer id risus: Sit amet sem egestas consectetur ut sed nisl.

      Proin tempor: Viverra efficitur.

      Pellentesque sed: At augue molestie feugiat.

      Sed ac dui diam: Quisque.

      Eget tellus: Ut leo cursus.

      Auctor sed: Quis odio.

      Cras enim mi: Ullamcorper quis.
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
  }),
  computed: {
  },
  async mounted() {
    this.publish('modal.show.login', {
      clickToClose: false,
      header: this.tStatic('signInModalHeader'),
      text: `${this.tStatic('signInModalText').replace('{pagename}', this.clientModel.pageName)}`,
      resetFunction: this.onModalClose,
      returnUrl: window.location.pathname + window.location.search.replace(/\?returnurl=/ig, '') + window.location.hash
    })
  },
  methods: {
    onModalClose() {
      window.location = this.clientModel.startPageUrl
    }
  }
}
</script>

<style lang="scss">

 .greyed-out {
  width: 100%;
  height: 100%;
  background-color: #ccc;
 }

 .greyed-out div {
  padding-left: measure(half);
  white-space: pre-line;
  filter: blur(4px);
 }

.wrapper__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: measure(half);
}

.wrapper__title {
  @include h3-semi-bold;
  margin: 0;
}

</style>
